import { render } from "./contactDetails.vue?vue&type=template&id=3b810cc8&scoped=true"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"

import "./contactDetails.vue?vue&type=style&index=0&id=3b810cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b810cc8"]])

export default __exports__